import { render, staticRenderFns } from "./parcelle_favoris.vue?vue&type=template&id=fb4875e8"
import script from "./parcelle_favoris.js?vue&type=script&lang=js&external"
export * from "./parcelle_favoris.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports